import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/logo.svg";
import Search from "../assets/search.svg";
import User from "../assets/user.svg";
import homeIcon from "../assets/icon/home.png";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import MobileNavbar from "./MobileNavbar";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#D5F9FF",
    padding: "0px 60px",
    width: "100%",
    maxWidth: "2200px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  menu_wrapper: {
    gap: "6px",
  },
  link: {
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    fontSize: "12px",
    lineHeight: "10px",
    fontWeight: 700,

    textTransform: "uppercase",
    letterSpacing: "2.04px",
    textDecoration: "none",
    color: "#222",
    fontFamily: "'Exo', sans-serif",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#fff",
      borderRadius: "20px",
    },
  },
  link_active: {
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    fontSize: "12px",
    lineHeight: "10px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "2.04px",
    textDecoration: "none",
    // color: theme.palette.info.contrastText,
    color: "#222",
    fontFamily: "'Exo', sans-serif",
    transition: "all 0.3s ease",
    background: "#fff",
    borderRadius: "20px",
  },

  sub_link: {
    padding: "0px !important",
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "2.04px",
    textDecoration: "none",
    // color: theme.palette.info.contrastText,
    color: "#222",
    fontFamily: "'Exo', sans-serif",
    borderBottom: `1px solid #F1F1F1`,
    "& a": {
      width: "100%",
      textDecoration: "none",
      color: "#222",
      borderBottom: `1px solid #F1F1F1`,
      fontFamily: "'Exo', sans-serif",
      fontSize: "12px",
      fontWeight: 700,
      padding: "10px 15px",
    },
  },
  icon_wrapper: {
    display: "flex",
    gap: "25px",
    justifyContent: "space-between",
  },
  link_right: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#fff",
    padding: "10px 30px",
    borderRadius: "50px",
    textDecoration: "none",
    color: "#555555 !important",
    fontFamily: "'Exo', sans-serif !important",
  },
}));
const WebsiteHeader = () => {
  const theme = useTheme();

  const classes = useStyles();
  const pathname = useLocation().pathname;

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const openSolution = Boolean(anchorEl);
  const openIndustries = Boolean(anchorEl2);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  return (
    <Box className={classes.root}>
      <Box
        sx={{
          display: { xs: "flex" },
          alignItems: { xs: "center" },
          justifyContent: { xs: "center" },
          width: { xs: "100%", md: "auto" },
        }}
      >
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            left: "20px",
            position: "absolute",
          }}
        >
          <MobileNavbar />
        </Box>
        <Box>
          <Link to={`${process.env.REACT_APP_WEBSITE_URL}`}>
            <img src={Logo} alt="" />
          </Link>
        </Box>
      </Box>
      <Box
        className={classes.menu_wrapper}
        sx={{ display: { xs: "none", md: "flex" } }}
      >
        <Link
          to={`${process.env.REACT_APP_WEBSITE_URL}`}
          className={
            pathname === process.env.REACT_APP_WEBSITE_URL
              ? classes.link_active
              : classes.link
          }
        >
          <img src={homeIcon} alt="" />
          {/* Home */}
        </Link>

        <Link
          to="#"
          onClick={handleClick}
          className={
            [
              "/kyc-compliance",
              "/id-document-verification",
              "/customer-onboarding",
              "/kyc-flow-builder",
              "/proof-of-address",
              "/age-verification",
            ].includes(pathname)
              ? classes.link_active
              : classes.link
          }
        >
          Solutions
        </Link>
        <Menu anchorEl={anchorEl} open={openSolution} onClose={handleClose}>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/kyc-compliance`}
              onClick={handleClose}
            >
              KYC Compliance
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/id-document-verification`}
              onClick={handleClose}
            >
              ID Document Verification
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/customer-onboarding`}
              onClick={handleClose}
            >
              Customer Onboarding
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/kyc-flow-builder`}
              onClick={handleClose}
            >
              KYC Flow Builder
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/proof-of-address`}
              onClick={handleClose}
            >
              Proof of Address
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/age-verification`}
              onClick={handleClose}
            >
              Age Verification
            </Link>
          </MenuItem>
        </Menu>
        {/* @ts-ignore */}
        <Link
          to="#"
          // @ts-ignore
          onClick={handleClick2}
          className={
            [
              "/financial-services",
              "/crypto",
              "/gaming-and-e-sports",
              "/legal-industry",
              "/healthcare",
              "/marketplaces",
            ].includes(pathname)
              ? classes.link_active
              : classes.link
          }
        >
          Industries
        </Link>
        <Menu anchorEl={anchorEl2} open={openIndustries} onClose={handleClose2}>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/financial-services`}
              onClick={handleClose}
            >
              Financial Services
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/crypto`}
              onClick={handleClose}
            >
              Crypto
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/gaming-and-e-sports`}
              onClick={handleClose}
            >
              Gaming and E-sports
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/legal-industry`}
              onClick={handleClose}
            >
              Legal Industry
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/healthcare`}
              onClick={handleClose}
            >
              Healthcare
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose2} className={classes.sub_link}>
            <Link
              to={`${process.env.REACT_APP_WEBSITE_URL}/marketplaces`}
              onClick={handleClose}
            >
              Marketplaces
            </Link>
          </MenuItem>
        </Menu>
        <Link
          to={`${process.env.REACT_APP_WEBSITE_URL}/pricing`}
          className={
            pathname === "/pricing" ? classes.link_active : classes.link
          }
        >
          PRICING
        </Link>
        {/* <Link
        to="/developers"
        className={
          pathname === "/developers" ? classes.link_active : classes.link
        }
      >
        Developers
      </Link> */}
        <Link
          to={`${process.env.REACT_APP_WEBSITE_URL}/contact-us`}
          className={
            pathname === "/contact-us" ? classes.link_active : classes.link
          }
        >
          CONTACT US
        </Link>
      </Box>
      <Box
        className={classes.icon_wrapper}
        sx={{ display: { xs: "none", md: "flex" } }}
      >
        {/* <Box>
        <Link to="/search">
          <img src={Search} alt="" />
        </Link>
      </Box> */}
        <Box>
          <Link
            to="https://console.certifymyid.com/"
            className={classes.link_right}
          >
            Account
            <img src={User} alt="" />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default WebsiteHeader;
